module.exports = __webpack_public_path__ + "media/djembe-pi.6ad0cee6.wav";